import React from "react";
import GDataBaseProvider from "../../components/graph/GDataBaseProvider";
import BaseLayout from "../../components/layout/BaseLayout";
import WholeInteractiveGraph from "../../components/graph/whole-graph/WholeInteractiveGraph";
import Link from "next/link";
import TextContainer from "../../components/layout/TextContainer";
import PageHeader from "../../components/general/PageHeader";




export default function GraphPage() {


  return (
    <div>
      <BaseLayout
        pageTitle="Lightning Network Graph Visualization"
        seoDescription="Visualize all lightning nodes and channels in one graph visualization. Filter by fees, channel count, scores, size and more. Find your node."
      >
              <PageHeader
        title="Lightning network graph"
        description="Visualization of nodes and channels"
      />

        <section className="">
          <div className="hidden md:flex flex-row-reverse  text-gray-900">
            <Link href="/graph/embed">
              <span className="hover:bg-gray-100 text-sm font-medium py-2 px-3 mb-2 uppercase cursor-pointer">Embed on your website</span>
            </Link>

          </div>
          <GDataBaseProvider >
            <WholeInteractiveGraph />
          </GDataBaseProvider>
        </section>
        <section className="pt-32">
          <TextContainer>
            <h2 className="text-lg font-bold text-gray-700">Embed the graph on your website</h2>

            <p>
              Embed the graph on you website, select your node and show your visitors a visualization
              where your node is located in the network.
            </p>
            <div className="flex justify-center mt-6">
              <Link href="/graph/embed">
                <span className="border text-viking-900 rounded border-viking-700 hover:bg-gray-100 text-sm font-medium py-2 px-3 mb-2 uppercase cursor-pointer">Embed on your website</span>
              </Link>
            </div>

          </TextContainer>

        </section>
      </BaseLayout>
    </div >
  );
}
